import { Row } from "@hex-insights/core";
import { useActivePageRegistration } from "@hex-insights/router";
import { ButtonLink } from "@s-i-s-i/see-learning.shared";
import { DataPrivacyStatement } from "../../../Components";
import { OnboardingLayout } from "../Components";
import { onboardingIndexPageInfo } from "../IndexPage/pageinfo";
import { onboardingProfilePageInfo } from "../ProfilePage/pageinfo";
import { onboardingPrivacyStatementPageInfo } from "./pageinfo";

export function OnboardingPrivacyStatementPage() {
	useActivePageRegistration(onboardingPrivacyStatementPageInfo);

	return (
		<OnboardingLayout
			page="privacy-statement"
			footerContent={
				<Row justify="space-between">
					<ButtonLink variant="tertiary" to={onboardingIndexPageInfo.to}>
						Back
					</ButtonLink>
					<ButtonLink variant="primary" to={onboardingProfilePageInfo.to}>
						Continue
					</ButtonLink>
				</Row>
			}
		>
			<DataPrivacyStatement />
		</OnboardingLayout>
	);
}
